export function resolveBackendUrl() {
  if (typeof window !== 'undefined' && window.__BACKEND_URL__) {
    return String(window.__BACKEND_URL__);
  }
  return process.env.REACT_APP_BACKEND || '';
}
